document.addEventListener('DOMContentLoaded', function(){

    const header = document.getElementById('main-header');

    // white bg on scroll
    window.addEventListener('scroll', function(){

        if ( window.scrollY > 0 )
        {
            header.classList.add('bg-white');
        }
        else
        {
            header.classList.remove('bg-white');
        }

    });

    // resize observer
    const setHeightVairable = (height = 0) => {
        document.documentElement.style.setProperty('--header-height', height + "px");
    }

    let prevHeight = 0;

    const resizeObserver = new ResizeObserver(entries => {
        for ( const entry of entries ) {

            const height = entry.borderBoxSize?.[0].blockSize;

            if ( typeof height === 'number' && height !== prevHeight ) {
                prevHeight = height;
                setHeightVairable( height );
            }

        }
    });

    resizeObserver.observe( header );

    // switch active
    const scrollLinks = header.querySelectorAll('a.scroll-to');
    const sectionIds = [...scrollLinks].map(link => new URL(link.href).hash);

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if ( entry.isIntersecting && entry.intersectionRatio >= 0.5 ){
                const id = entry.target.getAttribute('id');
                header.querySelector(`a.scroll-to.active`)?.classList.remove('active');
                header.querySelector(`a.scroll-to[href="#${id}"]`)?.classList.add('active')
            }

        });
    }, 
    {
        threshold: 0.5
    });

    sectionIds.forEach(id => {
        if ( id && document.querySelector(id) ) {
            observer.observe(document.querySelector(id));
        }
    });

});